export default class Media {
    private visible: boolean;
    title: string;
    filePath: string;
    desc: string;
    descShow: boolean;
    autoplay: boolean;

    constructor(
        visible: boolean,
        filePath?: string,
        title?: string,
        desc?: string,
        descShow?: boolean,
        autoplay?: boolean
    ) {
        this.visible = visible;
        if (filePath) {
            this.filePath = filePath;
        }
        if (title) {
            this.title = title;
        }
        if (desc) {
            this.desc = desc;
        }
        if (descShow) {
            this.descShow = descShow;
        }
        if (autoplay) {
            this.autoplay = autoplay;
        }
    }

    getVisible(): boolean {
        return this.visible;
    }

    open(): boolean {
        this.visible = true;
        return this.visible;
    }

    close(): boolean {
        this.visible = false;
        this.title = null;
        this.filePath = null;
        this.desc = null;
        // this.descShow="";
        return this.visible;
    }
}
